import React from 'react';
import { LicensePlan } from '@/types/license';
import { LicenseFeature } from '@/types/license';
import { groupFeatures } from '@/utils/featureUtils';
import { FeatureList } from '../features/FeatureList';
import { usePricing } from '../../contexts/PricingContext';
import { getPriceForPeriod } from '../../utils/pricingUtils';

interface LicenseVisualizerProps {
  plans: LicensePlan[];
}

export const LicenseVisualizer: React.FC<LicenseVisualizerProps> = ({ plans }) => {
  const { period } = usePricing();
  const allFeatures = plans[0]?.features || [];
  const featureGroups = groupFeatures(allFeatures);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {plans.map((plan) => {
        const price = getPriceForPeriod(plan, period);
        return (
          <div key={plan.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="bg-blue-600 p-6 text-white">
              <h3 className="text-xl font-bold">{plan.name}</h3>
              {price && (
                <p className="text-lg mt-2 opacity-90">{price}</p>
              )}
            </div>
          
          <div className="p-6">
            <p className="text-gray-600 mb-4">{plan.description}</p>
            
            {Object.entries(featureGroups).map(([groupName, features]) => (
              features.length > 0 && (
                <FeatureList
                  key={groupName}
                  groupName={groupName}
                  features={features.map((feature: LicenseFeature) => ({
                    ...feature,
                    included: plan.features.find(f => f.name === feature.name)?.included || false,
                    additionalInfo: plan.features.find(f => f.name === feature.name)?.additionalInfo
                  }))}
                />
              )
            ))}
          </div>
        </div>
        );
      })}
    </div>
  );
};